import { track, page, identifyUser } from '../lib/vendor/segment';
import { getDefaultProperties } from '../helper/tracking';
import { getAccountUidIfConfigured } from '../helper/account';
import { SegmentProperties } from '../types';
import { OnboardingTrackingPages } from '../constants';
import { refreshStores } from '../storage/stores';

export const trackEvent = ({
  event,
  properties,
  accountUid,
}: {
  event: string;
  properties?: SegmentProperties;
  accountUid?: string;
}) =>
  track({
    event,
    userId: accountUid || getAccountUidIfConfigured(),
    properties: Object.assign(getDefaultProperties(), properties),
  });

export const trackPageView = ({
  name,
  properties,
}: {
  name: OnboardingTrackingPages;
  properties?: SegmentProperties;
}) =>
  page({
    name,
    userId: getAccountUidIfConfigured(),
    properties: Object.assign(getDefaultProperties(), properties),
  });

export const identifyUserIfConfigured = () =>
  refreshStores().then(() => {
    const userId = getAccountUidIfConfigured();
    if (userId) {
      identifyUser(userId);
    }
  });
